import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

/**
 * Route-level pending state mirroring the real page's layout (header bar,
 * summary card, roster rows) so the load resolves without a layout jump.
 */
export function SessionDetailsSkeleton() {
	return (
		<div className="bg-base-200 pb-8">
			<div className="sticky top-0 z-10 border-b border-base-300 bg-base-100">
				<div className="mx-auto flex max-w-5xl items-center justify-between gap-2 px-4 py-3 md:py-4">
					<div className="flex min-w-0 items-center gap-3">
						<Skeleton className="h-8 w-8 shrink-0 rounded-md" />
						<div className="space-y-1.5">
							<Skeleton className="h-5 w-48 md:w-72" />
							<Skeleton className="h-3.5 w-28" />
						</div>
					</div>
					<Skeleton className="h-8 w-20 shrink-0 rounded-md md:w-40" />
				</div>
			</div>
			<div className="mx-auto max-w-5xl space-y-4 px-4 py-4 md:space-y-6 md:py-6">
				<Card>
					<CardContent className="p-4 md:p-6">
						<div className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between md:gap-8">
							<div className="min-w-0 flex-1 space-y-3">
								<Skeleton className="h-4 w-56" />
								<Skeleton className="h-8 w-44" />
								<Skeleton className="h-4 w-64" />
							</div>
							<div className="space-y-2 md:w-44">
								<Skeleton className="h-3.5 w-20 md:ml-auto" />
								<Skeleton className="h-6 w-14 md:ml-auto" />
								<Skeleton className="h-1.5 w-full rounded-full" />
							</div>
						</div>
					</CardContent>
				</Card>
				<Card>
					<CardHeader className="flex-row items-center justify-between gap-3 space-y-0 p-4 pb-3 md:p-6 md:pb-4">
						<Skeleton className="h-5 w-40" />
						<Skeleton className="h-8 w-24 rounded-md md:w-36" />
					</CardHeader>
					<CardContent className="p-0">
						<ul className="divide-y divide-base-300/70 border-t border-base-300/70">
							{["a", "b", "c", "d"].map((row) => (
								<li
									key={row}
									className="flex min-h-14 items-center gap-3 px-4 py-2.5 md:px-6"
								>
									<Skeleton className="h-9 w-9 shrink-0 rounded-full" />
									<Skeleton className="h-4 w-40 flex-none" />
									<Skeleton className="ml-auto h-7 w-24 rounded-full" />
								</li>
							))}
						</ul>
					</CardContent>
				</Card>
			</div>
		</div>
	);
}
